export default __webpack_public_path__ + "static/media/keto_drinks@2x.0eb30fda.jpg";